// resize an image by drawing it on a canvas
const canvasScale = (img: HTMLImageElement, max: number, mode: "width" | "height") => {
    // check if the image is already smaller than the max
    if (img[mode] <= max) return img.src;

    const canvas = document.createElement("canvas"),
        ctx = canvas.getContext("2d");

    // when canvas can not be created, just return the original image as a fallback
    if (ctx === null) return img.src;

    if (mode === "width") {
        canvas.width = max;
        canvas.height = canvas.width * (img.height / img.width);
    }

    if (mode === "height") {
        canvas.height = max;
        canvas.width = canvas.height * (img.width / img.height);
    }

    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    // use png here to support background transparency
    // this is crucial when users select a svg as project icon
    return canvas.toDataURL("image/png");
};

// load an image src as a promise
const loadImg = function (img: HTMLImageElement, url: string) {
    return new Promise((resolve, reject) => {
        img.src = url;
        img.onload = () => resolve(img);
        img.onerror = () => reject(img);
    });
};

export const ImagerResizer = async (
    url: string,
    max: number,
    mode: "width" | "height" | "both"
) => {
    let img = new Image();
    let resizedImage = "";

    if (mode === "width" || mode === "both") {
        await loadImg(img, url);
        resizedImage = canvasScale(img, max, "width");
    }

    if (mode === "height" || mode === "both") {
        resizedImage = canvasScale(img, max, "height");
    }

    return resizedImage;
};
